export default {
  getDimiss: "/employee/querydimission",//离职列表查询
  resume: "/employee/resume",//复制
  exportAll:"/employee/downloadempreport?status=100002&token=",//导出全部离职
}



// WEBPACK FOOTER //
// ./src/api/config/dimission.js